import { Item, NormalizedProductReview } from 'types';
import OverallRating from 'components/Collection/pages/product/ProductReviews/OverallRating';
import { hasCurrentBlockOutDates, hasFutureBlockOutDates } from 'utils/utils';

type TitleGroupProps = {
  isBlockedOut: boolean | null;
  product: Item;
  reviews: NormalizedProductReview;
  displayTitleAsH2?: boolean;
};

const TitleGroup = ({ product, reviews, displayTitleAsH2 }: TitleGroupProps) => {
  const generalBlockoutDates = product.blockout_dates?.filter((date) => date.availability === 'general');
  const hasLimitedAvailability =
    hasCurrentBlockOutDates(generalBlockoutDates ?? []) || hasFutureBlockOutDates(generalBlockoutDates ?? []);

  const comingSoon = product.blockout_dates?.filter((date) => date.availability === 'coming-soon');

  const hasComingSoonAvailability = hasCurrentBlockOutDates(comingSoon ?? []);

  const isSuitOrTux = product.type === 'tuxedo' || product.type === 'suit';

  return (
    <div className="space-y-8">
      {(hasLimitedAvailability || hasComingSoonAvailability) && (
        <div className="flex">
          <p className="text-sm bg-black py-4 px-8 leading-4 text-white">
            {hasLimitedAvailability && !hasComingSoonAvailability && `Limited Availability`}
            {hasComingSoonAvailability && `Coming Soon`}
          </p>
        </div>
      )}

      {isSuitOrTux && <OverallRating reviews={reviews} />}
      {displayTitleAsH2 ? (
        <h2 className="text-h2-display">{product.display_name}</h2>
      ) : (
        <h1 className="text-h2-display">{product.display_name}</h1>
      )}
    </div>
  );
};

export default TitleGroup;
